import makeStyles from "@mui/styles/makeStyles";

export const usePaginationStyles = makeStyles((theme) => ({
  root: {
    "& > .MuiPagination-ul > li": {
      "& > button, & .MuiPaginationItem-ellipsis": {
        marginLeft: 16,
        [theme.breakpoints.up("md")]: {
          marginLeft: 30,
        },
      },
      "&:first-child": {
        "& > button": {
          marginLeft: 0,
        },
      },
    },
  },
}));

export const usePaginationItemStyles = makeStyles((theme) => ({
  root: {
    width: 20,
    minWidth: 20,
    height: 20,
    margin: 0,
    padding: 0,
    fontSize: 14,
    lineHeight: "20px",
    color: theme.palette.grey[700],
  },
  selected: {
    backgroundColor: "transparent !important",
    fontWeight: 600,
    color: theme.palette.grey[900],
  },
  disabled: {
    opacity: "1 !important",
    color: theme.palette.grey[500],
  },
}));
